module.exports = __webpack_public_path__ + "static/media/icon-mantra.41ddf667.png";